const universalPediatricToAdultMap = {
  // This mapping does not match the backend's map, it is for display purposes only
  A: 4,
  B: 5,
  C: 6,
  D: 7,
  E: 8,
  F: 9,
  G: 10,
  H: 11,
  I: 12,
  J: 13,
  K: 20,
  L: 21,
  M: 22,
  N: 23,
  O: 24,
  P: 25,
  Q: 26,
  R: 27,
  S: 28,
  T: 29,
  AS: 57,
  BS: 58,
  CS: 59,
  DS: 60,
  ES: 61,
  FS: 62,
  GS: 63,
  HS: 64,
  IS: 65,
  JS: 66,
  KS: 67,
  LS: 68,
  MS: 69,
  NS: 70,
  OS: 71,
  PS: 72,
  QS: 73,
  RS: 74,
  SS: 75,
  TS: 76
};
const universalToFDIToothMap = {
  "1": "18",
  "2": "17",
  "3": "16",
  "4": "15",
  "5": "14",
  "6": "13",
  "7": "12",
  "8": "11",
  "9": "21",
  "10": "22",
  "11": "23",
  "12": "24",
  "13": "25",
  "14": "26",
  "15": "27",
  "16": "28",
  "17": "38",
  "18": "37",
  "19": "36",
  "20": "35",
  "21": "34",
  "22": "33",
  "23": "32",
  "24": "31",
  "25": "41",
  "26": "42",
  "27": "43",
  "28": "44",
  "29": "45",
  "30": "46",
  "31": "47",
  "32": "48"
};
const pediatricUniversalToFDIToothMap = {
  A: "55",
  B: "54",
  C: "53",
  D: "52",
  E: "51",
  F: "61",
  G: "62",
  H: "63",
  I: "64",
  J: "65",
  K: "75",
  L: "74",
  M: "73",
  N: "72",
  O: "71",
  P: "81",
  Q: "82",
  R: "83",
  S: "84",
  T: "85"
};
const combinedUniversalToFDIMap = {
  ...pediatricUniversalToFDIToothMap,
  ...universalToFDIToothMap
};
const universalToFDIQuadrantMap = {
  1: "2",
  2: "1",
  3: "4",
  4: "3"
};
const universalToFDIDisplay = (toothId) => {
  const toothIdToString = String(toothId).toUpperCase();
  if (isValidUniversalToothId(toothIdToString)) {
    return combinedUniversalToFDIMap[toothIdToString];
  }
  return "Unknown";
};
const universalQuadrantsToFDIDisplay = (quadrant) => {
  if (isValidUniversalQuadrant(quadrant)) {
    return universalToFDIQuadrantMap[quadrant];
  }
  return "";
};
function normalizeToothIds(toothId) {
  if (!toothId || toothId === "0") {
    return 0;
  }
  if (typeof toothId === "number") {
    return toothId;
  }
  if (typeof toothId === "string" && (toothId.toLowerCase() === "unknown" || toothId.includes("_"))) {
    return -1;
  }
  const isUniversalOrFdi = isNumberOrNumericString(toothId);
  if (isUniversalOrFdi) {
    return Number(toothId);
  }
  const isPediatricTooth2 = isPediatricToothId(toothId);
  if (isPediatricTooth2) {
    return universalPediatricToAdultMap[toothId.toUpperCase()];
  }
  throw `unexpected toothId: ${toothId}`;
}
function isNumberOrNumericString(value) {
  return !isNaN(Number(value)) && value !== "";
}
const isPediatricTooth = new RegExp(/[A-Ta-t]/);
function isPediatricToothId(value) {
  return isPediatricTooth.test(value);
}
function isValidUniversalToothId(toothId) {
  const key = toothId;
  return key in combinedUniversalToFDIMap;
}
function isValidUniversalQuadrant(quadrant) {
  return quadrant in universalToFDIQuadrantMap;
}
const quadrantNumberToAbbreviation = {
  1: "UR",
  2: "UL",
  3: "LL",
  4: "LR"
};
function getQuadrantAbbreviation(quadrant) {
  return quadrantNumberToAbbreviation[quadrant] || "";
}
export {
  combinedUniversalToFDIMap,
  getQuadrantAbbreviation,
  isPediatricToothId,
  normalizeToothIds,
  quadrantNumberToAbbreviation,
  universalPediatricToAdultMap,
  universalQuadrantsToFDIDisplay,
  universalToFDIDisplay
};
